import { useNavigate } from "react-router-dom";
import { User } from "../model/User";
import { UserRole } from "../model/UserRole";
import { toast } from "react-toastify";

/**
 * Hook permettant de gérer l'authentification
 * Il permet d'accéder à plusieurs éléments
 * - login: le login de l'utilisateur connecté
 * - token: le token de l'utilisateur connecté
 * - loginAction: fonction permettant de se connecter (stoker les informations de connexion dans le local storage et rediriger vers la page /route1)
 * - logOutAction: fonction permettant de se déconnecter (supprimer les informations de connexion du local storage et rediriger vers la page /login)
 *
 * @returns
 */

export type UserAuth = { newLogin: string; token: string; roles: string[] };

export default function useAuth() {
  let navigate = useNavigate();

  const token = localStorage.getItem("token") || "";
  const roles: UserRole[] = JSON.parse(localStorage.getItem("roles") || "[]");
  let login = localStorage.getItem("login") || "";

  function loginAction(userAuth: UserAuth) {
    localStorage.setItem("token", userAuth.token);
    localStorage.setItem("roles", JSON.stringify(userAuth.roles));
    localStorage.setItem("login", userAuth.newLogin);
    navigate("/home");
  }

  function logOutAction(tokenExpired: boolean) {
    localStorage.removeItem("token");
    localStorage.removeItem("login");
    localStorage.removeItem("roles");
    if (tokenExpired) {
      navigate("/login", { state: { error: "Your session has expired. Please log in again." } });
    }
    navigate("/login");
  }

  return { login, token, roles, loginAction, logOutAction };
}
